import React, { useState } from 'react';
import './Faq.css';
import up from '../../assets/images/up.svg';
import down from '../../assets/images/down.svg';
import avatar from '../../assets/images/avatar.svg';
import ArrowIcon from '../../assets/images/whitevectot.svg';

const FAQ_DATA = [
  {
    question: 'What is JioDAM and how does it help?',
    answer:
      'JioDAM is a secure and efficient Digital Asset Management (DAM) solution that helps organizations *store, organize, retrieve, and manage digital assets* like images, documents, videos, and more. It streamlines collaboration, improves accessibility, and ensures assets are always up-to-date.',
  },
  {
    question: 'Who can use JioDAM?',
    answer:
      'We support a wide range of file formats including images (JPG, PNG, SVG), documents (PDF, DOC), and media files (MP4, MP3). Our system is constantly updated to handle new formats.',
  },
  {
    question: 'Is my data secure in JioDAM?',
    answer:
      'We implement industry-standard security measures including end-to-end encryption, role-based access control, and regular security audits to ensure your assets are protected.',
  },
  {
    question: 'How can I find and retrieve assets quickly??',
    answer:
      'We provide 24/7 technical support through multiple channels including email, phone, and live chat. Our dedicated support team ensures quick resolution of any issues you may encounter.',
  },
  {
    question: 'Do I need any special software to use JioDAM??',
    answer:
      "Yes, we offer a free trial period where you can explore all features of JioDAM. This helps you make an informed decision about whether JioDAM meets your organization's needs.",
  },
];
const handleContactus=()=>{
  window.location.href='https://forms.cloud.microsoft/r/R2gr83AJiL';
}
const FaqItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <>
      <div className="faq-item">
        <div className="faq-question" onClick={onClick}>
          <h3>{question}</h3>
          <img src={isOpen ? down : up} alt="arrow" className="arrow-icon" />
        </div>
        <div className={`faq-answer ${!isOpen ? 'closed' : ''}`}>{answer}</div>
      </div>
      <hr className="faq-separator" />
    </>
  );
};

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const visibleFaqs =  FAQ_DATA 

  const handleFaqClick = (index) => {
    setOpenIndex(index === openIndex ? -1 : index);
  };

  return (
    <div className="faq-container">
      <h2>
        Frequently Asked Questions
      </h2>
      <p className='faq-description'>Everything you need to know about the product and billing.</p>
      <div className="faq-list">
        {visibleFaqs.map((faq, index) => (
          <FaqItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={index === openIndex}
            onClick={() => handleFaqClick(index)}
          />
        ))}
      </div>
    <div className='still-have-questions'>
      <img src={avatar} alt="avatar" />
      <p className='still-have-q-title'>Still have questions?</p>
      <p className='still-have-q-description'>Can’t find the answer you’re looking for? Please chat to our friendly team.</p>
      <button className='demo-btn-purple' onClick={handleContactus}>
                Book A Demo
                <img src={ArrowIcon} alt="arrow" className="demo-arrow" />
              </button>

    </div>
    </div>
  );
};

export default Faq;
